import MaterialIssuanceHeaderFilter from './MaterialIssuanceHeaderFilter';
import { useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../../../store';
import dayjs from 'dayjs';
import { dateFormat } from '../../../lib/utils';
import { MaterialIssuanceType } from '../../../lib/enums';
import { useDownLoadFile } from '../../../hooks';
import { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { Empty, Spin, Table } from 'antd';

interface RowData {
  [key: string]: any;
}

const MaterialIssuancePage = () => {
  const api = '/reports/issuance-status';
  const [searchParams] = useSearchParams();
  const { user } = useAuthStore();
  const [storedArrayBuffer, setStoredArrayBuffer] = useState(null);

  const startDate =
    searchParams.get('startDate') === undefined ||
    searchParams.get('startDate') === null
      ? dayjs().subtract(6, 'month').format(dateFormat)
      : searchParams.get('startDate');

  const endDate =
    searchParams.get('endDate') === undefined ||
    searchParams.get('endDate') === null
      ? dayjs().add(2, 'month').format(dateFormat)
      : searchParams.get('endDate');
  const type =
    searchParams.get('type') === undefined || searchParams.get('type') === null
      ? MaterialIssuanceType.DAILY
      : searchParams.get('type');

  const { data, isLoading, isSuccess, isError } = useDownLoadFile(api, {
    localtion_id: searchParams.get('locationId') || user?.defaultLocation?.id,
    categoryId: searchParams.get('categoryId') || '',
    startDate: searchParams.get('startDate') || startDate,
    endDate: searchParams.get('endDate') || endDate,
    type: searchParams.get('type') || type,
  });

  const exportReport = () => {
    if (storedArrayBuffer !== null) {
      const url = window.URL.createObjectURL(new Blob([storedArrayBuffer]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'issuance_report.xlsx');
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    }
  };

  // useEffect(() => {
  //   if (!isLoading && isSuccess) {
  //     setStoredArrayBuffer(data);
  //     const workbook = XLSX.read(data, { sheetRows: 20 });
  //     const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  //     const table = XLSX.utils.sheet_to_html(worksheet);
  //     setHtmlContent(table);
  //     setShowTable(true);
  //   }
  // }, [showTable, htmlContent, isLoading, data]);

  const [dataSource, setDataSource] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);

  useEffect(() => {
    if (!isLoading && isSuccess) {
      setStoredArrayBuffer(data);
      const workbook = XLSX.read(data, { type: 'binary' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData: any = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Extract headers from first row
      const headers = jsonData[2].map((header: string) => ({
        title: header,
        dataIndex: header,
        key: header,
      }));

      const dataSource: RowData[] = jsonData
        .slice(3)
        .filter((row: any) => row.length > 0 && row[1] !== undefined)
        .map((row: any[], index: number) => {
          const rowData: RowData = {};
          headers.forEach((header: any, columnIndex: any) => {
            rowData[header.dataIndex] = row[columnIndex];
          });
          // Perform computation
          // Add computed value to rowData
          rowData['TOTAL'] = Object.values(rowData)
            .slice(4, 53)
            .reduce((acc: number, currentValue: any) => {
              // Check if currentValue is a number before adding it to the accumulator
              if (!isNaN(currentValue)) {
                return acc + currentValue;
              }
              return acc;
            }, 0);

          return {
            key: index.toString(),
            ...rowData,
          };
        });

      setColumns(headers);
      setDataSource(dataSource);
    }
  }, [isLoading, isSuccess, data]);

  return (
    <>
      <div className={'page-wrapper'}>
        {user !== null && (
          <MaterialIssuanceHeaderFilter
            data={data}
            startDate={startDate}
            endDate={endDate}
            userLocation={user?.defaultLocation?.id}
            type={type}
            exportReport={exportReport}
          />
        )}
        {isLoading && <Spin spinning={true} fullscreen />}
        {isSuccess && (
          // <div
          //   className={'overflow-auto'}
          //   dangerouslySetInnerHTML={{ __html: htmlContent }}
          // />
          <Table
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            rowKey={(record) => record.key}
          />
        )}

        {isError && <Empty />}
      </div>
    </>
  );
};

export default MaterialIssuancePage;
